import store from '@/store/index';

function isGerberType(file_type) {
    return file_type === "rou" || file_type === "drl" || file_type === "gbr";
}


export async function routerFilesAndDetectLayer(fileList) {
    console.log("routerFilesAndDetectLayer", fileList);
    const commonList = []
    const gbrList = []
    fileList.forEach(file => {
        if (isGerberType(file.file_type)) {
            gbrList.push(file)
        }else {
            commonList.push(file)
        }
    })
    gbrList.forEach(fileInfo => {
        if (fileInfo.file_type === "drl") {
            fileInfo.layer = refiningDrlLayer(fileInfo.name) // 转孔需要细化pth/npth
        } else if (fileInfo.file_type === "gbr") {
            fileInfo.layer = getLayerByName(fileInfo.name)
            console.log("fileInfo.layer", fileInfo.name, fileInfo.layer)
        }
    })

    return [commonList, gbrList]
}

// 配置化，远程控制


const directKeys = ["outline", "top_layer", "bottom_layer", "top_solder_layer", "bottom_solder_layer",
    "top_paste", "bottom_paste", "top_silk_layer", "bottom_silk_layer"];

export function refiningDrlLayer(filePath) {
    const keywords = store.state.layerMapConfig
    const lowerFile = filePath.toLowerCase();
    if (keywords.npth.some(keyword => lowerFile.includes(keyword))) {
        return "drill_npth";
    }
    if (keywords.pth.some(keyword => lowerFile.includes(keyword))) {
        return "drill_pth";
    }
    return "drill"
}



// ToDo 孔符逻辑尚未明确
export function getLayerByName(fileName) {
    const keywords = store.state.layerMapConfig
    const ext = fileName.split(".").pop().toLowerCase();
    const lowerFile = fileName.toLowerCase();

    if (["drl", "drill", "exc", "xln", "drd", "tap"].includes(ext)) {
        // ToDo 基本上不会到这一层，因为内容判定比文件名还严格，如果内容都没判定出是drl，这里反而应该报错
        return "drill";
    } else if (ext === "ipc") {
        return "ipc";
    } else if (ext === "rou") {
        return "rou";
    }

    if (keywords.outline.some(keyword => lowerFile.includes(keyword))) {
        return "outline";
    }
    if (keywords.outline_re){
        for (let i=0; i < keywords.outline_re.length; i++) {
            const outlineRegex = new RegExp(keywords.outline_re[i]);
            if (outlineRegex.test(lowerFile)) {
                return "outline";
            }
        }
    }

    if (keywords.symbol.some(keyword => lowerFile.includes(keyword))) {
        return "symbol";
    }

    if (keywords.top.some(keyword => lowerFile.includes(keyword))) {
        if (keywords.solder.some(keyword => lowerFile.includes(keyword))) {
            return "top_solder_layer";
        } else if (keywords.silk.some(keyword => lowerFile.includes(keyword))) {
            return "top_silk_layer";
        } else if (keywords.paste.some(keyword => lowerFile.includes(keyword))) {
            return "top_paste";
        } else {
            return "top_layer";
        }
    } else if (keywords.bottom.some(keyword => lowerFile.includes(keyword))) {
        if (keywords.solder.some(keyword => lowerFile.includes(keyword))) {
            return "bottom_solder_layer";
        } else if (keywords.silk.some(keyword => lowerFile.includes(keyword))) {
            return "bottom_silk_layer";
        } else if (keywords.paste.some(keyword => lowerFile.includes(keyword))) {
            return "bottom_paste";
        } else {
            return "bottom_layer";
        }
    }

    for (let i=0; i < directKeys.length; i++) {
        const directKey = directKeys[i];
        const keyList = keywords[directKey]
        for (let j = 0; j < keyList.length; j++) {
            const keyword = keyList[j];
            if (lowerFile.includes(keyword)){
                console.log(`getLayerByName match key:${keyword} lowerFile:${lowerFile}, directKey:${directKey}`)
                return directKey;
            }
        }
    }

    return "other";
}

